import classNames from 'classnames'
import { createElement, FunctionComponent } from 'react'
import { IconProps } from './IconProps'
import { useIconStyles } from './IconStyles'

export const iconStaticClassName = 'pop-icon'
export const Icon: FunctionComponent<IconProps> = ({
  className,
  color = 'inherit',
  icon,
  size = 'inherit',
  ...restProps
}) => {
  const hasAccessibleAttr = Boolean(restProps['aria-describedby'] || restProps['aria-label'])
  if (!hasAccessibleAttr && restProps['aria-hidden'] === undefined) {
    restProps['aria-hidden'] = true
  }
  const classes = useIconStyles({ color, size })
  if (!icon || (typeof icon === 'function' && icon({}) === undefined)) {
    return null
  }
  return createElement(icon, {
    className: classNames([classes.root, iconStaticClassName, className]),
    color,
    width: undefined,
    height: undefined,
    ...restProps,
  })
}

Icon.displayName = 'Icon'
